import { Pipe, PipeTransform } from '@angular/core';
import { DecimalPipe } from '@angular/common';

@Pipe({
    name: 'expNumber',
    pure: true
})
export class ExpNumber implements PipeTransform {

    constructor(private readonly decimalPipe: DecimalPipe) { }

    public transform(value: number, valueName: string, tempParameters: any): any {
        const tempNumber: any = tempParameters[valueName];
        let ret = '';
        if (tempNumber == null || tempNumber === undefined) {
            if (!isNaN(value)) {
                ret = this.decimalPipe.transform(value, '1.0-10');
            }
        }
        else if (tempNumber === '' || (isNaN(tempNumber) && tempNumber.indexOf('e') > 0)) {
            ret = tempNumber;
        }
        else {
            ret = this.decimalPipe.transform(value, '1.0-10');
        }

        return ret;
    }
}
